import { Autocomplete, TextField, Tooltip } from "@mui/material";
import { ProductProps } from "../../interfaces/interfaces";
import styles from "../components.module.sass";

export const ProductSelectorByName = ({
  options,
  onSelectName,
  value,
  size,
}: {
  options: ProductProps[];
  onSelectName: (newValue: any) => void;
  value?: ProductProps;
  size?: number;
}) => {
  const defaultProps = {
    options: options,
    getOptionLabel: (option: ProductProps) => option.name,
  };

  return (
    <Tooltip title={value?.name || ""} arrow>
      <Autocomplete
        renderOption={(props, option) => {
          return (
            <li {...props} key={option.id}>
              {option.name}
            </li>
          );
        }}
        value={value}
        isOptionEqualToValue={(option, value) => {
          return true;
        }}
        onChange={(_, newValue) => newValue && onSelectName(newValue)}
        {...defaultProps}
        disablePortal
        className={styles.textField}
        sx={{ minWidth: 260 }}
        renderInput={(params) => <TextField {...params} label="Description" />}
      />
    </Tooltip>
  );
};
